<template>
  <div>
    <detail-layout ref="layout" :tableCfg="tableCfg">
      <template slot="FormLayout" scope="props">
        <b-form ref="form" class="col-md-6 offset-md-2" autocomplete="off">
          <div v-if="dataValid" >
            <detail-field label="Login" field="usr_login_name" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
            <detail-field label="First Name" field="usr_first_name" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
            <detail-field label="Last Name" field="usr_last_name" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
            <detail-field label="Role" field="usr_role_id" :optionListApiUrl="'/userroles/choice/'" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
            <detail-field label="Active" field="usr_active" type="boolean" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
            <detail-field label="Filter Active Contracts" field="usr_filter_active" type="boolean" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="ok" :validator="validator"/>
          </div>
        </b-form>
      </template>
      <template slot="ExtraOptions" scope="props">
          <b-dropdown  v-if="privUser" variant="default" size="sm">
            <template slot="button-content"> <i class="fa fa-cog"></i> </template>
            <b-dropdown-item v-if="isReadOnly" @click="$refs.modalSetPassword.show()">Set Password</b-dropdown-item>
          </b-dropdown>
      </template>
    </detail-layout>
    <b-modal ref="modalSetPassword" title="Set Password" @ok="okPassword">
      <b-form ref="pwform" class="col-md-6 offset-md-2" autocomplete="off">
        <!-- <detail-field label="Password" field="pw1" :rec="pwRec" :isReadOnly="false" vvalidate="required"/>
        <detail-field label="Repeat Password" field="pw2" :rec="pwRec" :isReadOnly="false" vvalidate="required|confirmed:pw1"/> -->
        <b-form-input type="password" v-model="pw1" data-vv-as="PW1" name="pw1"/>
        <b-form-input type="password" v-model="pw2" data-vv-as="PW2" name="pw2"/>
        <b-alert variant="danger" :show="pw1 !== pw2">Passwords do not match</b-alert>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import api from '../../api'
import DetailMixin from '../../components/DetailMixin'
import FieldDefs from './FieldDefs.js'

export default {
  name: 'user_detail',
  mixins: [DetailMixin],
  data () {
    return {
      tableCfg: FieldDefs,
      pw1: '',
      pw2: '',
      pwmessage: ''
    }
  },
  methods: {
    okPassword (event) {
      if (this.pw1 === this.pw2) {
        api.putUpdate('/users/' + this.$refs.layout.rec.id, {usr_login_password: this.pw1}, data => { }, 'setting password', this.$refs.layout.$refs.alert)
      } else {
        event.cancel()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Detail.vue?ee861f4a